// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/registration/register/documents/firstparty/v1/create_document.proto

/* eslint-disable */
import { ApiDocType, apiDocTypeFromJSON, apiDocTypeToJSON, ApiDocument } from "./document";

/** Request message for creating a document */
export interface ApiCreateDocumentRequest {
  /** The file content to upload (binary) */
  readonly content: Uint8Array;
  /** Type of the subject the document belongs to (Organization or Stakeholder) */
  readonly subjectType: string;
  /** Unique identifier of the subject the document belongs to */
  readonly subjectId: string;
  /** Type of the document */
  readonly docType: ApiDocType;
  /** Subtype of the document (e.g., eu_passport) */
  readonly docSubtype?: string | null | undefined;
}

/** Response message for creating a document */
export interface ApiCreateDocumentResponse {
  /** The created document */
  readonly document: ApiDocument | null;
}

/** Error codes for CreateDocument operation */
export interface ApiCreateDocumentErrors {
}

/** Method not allowed error codes */
export const ApiCreateDocumentErrorsMethodNotAllowedError = {
  /** METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED - Unspecified method not allowed error */
  METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED: "METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED",
  /** METHOD_NOT_ALLOWED_ERROR_DOCUMENT_NOT_IN_DRAFT - Document cannot be created because registration is not in draft status */
  METHOD_NOT_ALLOWED_ERROR_DOCUMENT_NOT_IN_DRAFT: "METHOD_NOT_ALLOWED_ERROR_DOCUMENT_NOT_IN_DRAFT",
} as const;

export type ApiCreateDocumentErrorsMethodNotAllowedError =
  typeof ApiCreateDocumentErrorsMethodNotAllowedError[keyof typeof ApiCreateDocumentErrorsMethodNotAllowedError];

export namespace ApiCreateDocumentErrorsMethodNotAllowedError {
  export type METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED =
    typeof ApiCreateDocumentErrorsMethodNotAllowedError.METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED;
  export type METHOD_NOT_ALLOWED_ERROR_DOCUMENT_NOT_IN_DRAFT =
    typeof ApiCreateDocumentErrorsMethodNotAllowedError.METHOD_NOT_ALLOWED_ERROR_DOCUMENT_NOT_IN_DRAFT;
}

export function apiCreateDocumentErrorsMethodNotAllowedErrorFromJSON(
  object: any,
): ApiCreateDocumentErrorsMethodNotAllowedError {
  switch (object) {
    case 0:
    case "METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED":
      return ApiCreateDocumentErrorsMethodNotAllowedError.METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED;
    case 1:
    case "METHOD_NOT_ALLOWED_ERROR_DOCUMENT_NOT_IN_DRAFT":
      return ApiCreateDocumentErrorsMethodNotAllowedError.METHOD_NOT_ALLOWED_ERROR_DOCUMENT_NOT_IN_DRAFT;
    default:
      return ApiCreateDocumentErrorsMethodNotAllowedError.METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED;
  }
}

export function apiCreateDocumentErrorsMethodNotAllowedErrorToJSON(
  object: ApiCreateDocumentErrorsMethodNotAllowedError,
): string {
  switch (object) {
    case ApiCreateDocumentErrorsMethodNotAllowedError.METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED:
      return "METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED";
    case ApiCreateDocumentErrorsMethodNotAllowedError.METHOD_NOT_ALLOWED_ERROR_DOCUMENT_NOT_IN_DRAFT:
      return "METHOD_NOT_ALLOWED_ERROR_DOCUMENT_NOT_IN_DRAFT";
    default:
      return "METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED";
  }
}

/** Validation error codes */
export const ApiCreateDocumentErrorsUnprocessableEntityError = {
  /** UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED - Unspecified validation error */
  UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED: "UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED",
  /** UNPROCESSABLE_ENTITY_ERROR_VALIDATION_FAILED - Validation failed */
  UNPROCESSABLE_ENTITY_ERROR_VALIDATION_FAILED: "UNPROCESSABLE_ENTITY_ERROR_VALIDATION_FAILED",
} as const;

export type ApiCreateDocumentErrorsUnprocessableEntityError =
  typeof ApiCreateDocumentErrorsUnprocessableEntityError[keyof typeof ApiCreateDocumentErrorsUnprocessableEntityError];

export namespace ApiCreateDocumentErrorsUnprocessableEntityError {
  export type UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED =
    typeof ApiCreateDocumentErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED;
  export type UNPROCESSABLE_ENTITY_ERROR_VALIDATION_FAILED =
    typeof ApiCreateDocumentErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_VALIDATION_FAILED;
}

export function apiCreateDocumentErrorsUnprocessableEntityErrorFromJSON(
  object: any,
): ApiCreateDocumentErrorsUnprocessableEntityError {
  switch (object) {
    case 0:
    case "UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED":
      return ApiCreateDocumentErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED;
    case 1:
    case "UNPROCESSABLE_ENTITY_ERROR_VALIDATION_FAILED":
      return ApiCreateDocumentErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_VALIDATION_FAILED;
    default:
      return ApiCreateDocumentErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED;
  }
}

export function apiCreateDocumentErrorsUnprocessableEntityErrorToJSON(
  object: ApiCreateDocumentErrorsUnprocessableEntityError,
): string {
  switch (object) {
    case ApiCreateDocumentErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED:
      return "UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED";
    case ApiCreateDocumentErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_VALIDATION_FAILED:
      return "UNPROCESSABLE_ENTITY_ERROR_VALIDATION_FAILED";
    default:
      return "UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED";
  }
}

export const ApiCreateDocumentRequest: MessageFns<ApiCreateDocumentRequest> = {
  fromJSON(object: any): ApiCreateDocumentRequest {
    return {
      content: isSet(object.content) ? bytesFromBase64(object.content) : new Uint8Array(0),
      subjectType: isSet(object.subject_type) ? globalThis.String(object.subject_type) : "",
      subjectId: isSet(object.subject_id) ? globalThis.String(object.subject_id) : "",
      docType: isSet(object.doc_type) ? apiDocTypeFromJSON(object.doc_type) : ApiDocType.DOC_TYPE_UNSPECIFIED,
      docSubtype: isSet(object.doc_subtype) ? globalThis.String(object.doc_subtype) : null,
    };
  },

  toJSON(message: ApiCreateDocumentRequest): unknown {
    const obj: any = {};
    if (message.content !== undefined && message.content !== null) {
      obj.content = base64FromBytes(message.content);
    }
    if (message.subjectType !== undefined && message.subjectType !== null) {
      obj.subject_type = message.subjectType;
    }
    if (message.subjectId !== undefined && message.subjectId !== null) {
      obj.subject_id = message.subjectId;
    }
    if (message.docType !== undefined && message.docType !== null) {
      obj.doc_type = apiDocTypeToJSON(message.docType);
    }
    if (message.docSubtype !== undefined && message.docSubtype !== null) {
      obj.doc_subtype = message.docSubtype;
    }
    return obj;
  },
};

export const ApiCreateDocumentResponse: MessageFns<ApiCreateDocumentResponse> = {
  fromJSON(object: any): ApiCreateDocumentResponse {
    return { document: isSet(object.document) ? ApiDocument.fromJSON(object.document) : null };
  },

  toJSON(message: ApiCreateDocumentResponse): unknown {
    const obj: any = {};
    if (message.document !== undefined && message.document !== null) {
      obj.document = ApiDocument.toJSON(message.document);
    }
    return obj;
  },
};

export const ApiCreateDocumentErrors: MessageFns<ApiCreateDocumentErrors> = {
  fromJSON(_: any): ApiCreateDocumentErrors {
    return {};
  },

  toJSON(_: ApiCreateDocumentErrors): unknown {
    const obj: any = {};
    return obj;
  },
};

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
